import script from "./master.vue?vue&type=script&setup=true&lang=ts"
export * from "./master.vue?vue&type=script&setup=true&lang=ts"

import "./master.vue?vue&type=style&index=0&id=18473d0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18473d0f"]])

export default __exports__